package com.eladfinish.bible.contest.screens.main.data

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.unit.dp

/**
 * Telegram's paper plane, without the disc around it, so it sits with the other main-screen
 * icons, which are all bare glyphs. The path is the plane of the Telegram logo; the viewport
 * is cropped to it. The icon is tinted at render time, so the color here is irrelevant.
 */
val TelegramIcon: ImageVector by lazy {
    ImageVector.Builder(
        name = "Telegram",
        defaultWidth = 24.dp,
        defaultHeight = 24.dp,
        viewportWidth = PLANE_VIEWPORT_SIZE,
        viewportHeight = PLANE_VIEWPORT_SIZE,
    ).apply {
        addGroup(translationX = -PLANE_VIEWPORT_LEFT, translationY = -PLANE_VIEWPORT_TOP)
        addPath(
            pathData = PathParser().parsePathString(TELEGRAM_PLANE_PATH).toNodes(),
            fill = SolidColor(Color.Black),
        )
        clearGroup()
    }.build()
}

// The plane's bounding box inside the 24x24 logo, squared and padded by 6% on each side.
private const val PLANE_VIEWPORT_LEFT = 3.702f
private const val PLANE_VIEWPORT_TOP = 5.322f
private const val PLANE_VIEWPORT_SIZE = 14.662f

private const val TELEGRAM_PLANE_PATH =
    "M16.906 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472" +
        "-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902" +
        "-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23" +
        ".007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345" +
        "-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789" +
        ".027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
